function RelationIcon({ size }: any) {
  const dimensions = size || 24;
  return (
    <svg width={dimensions} height={dimensions} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m15 2 5 5M8.5 12.5h7m-7 3h7m0-3L13 10m-2 8-2.5-2.5M5 22h14a1 1 0 0 0 1-1V7h-5V2H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1z"
        stroke="#192048"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default RelationIcon;
